const _fetch = process.env.REACT_APP_TPICAP_ENV == 'test' ? 
require('./__mocks__/mockfetch').default : fetch;
export default _fetch;